/*
 * O "Resumir" do mapa do tópico e os
 * resumos curtos na lista de tópicos.
 *
 * O botão entra no fim do mapa do tópico, numa seção própria
 * (`topic-map__additional-contents`), e só aparece quando há um resumo pronto
 * ou quando a pessoa pode gerar um num tópico com postagens bastantes.
 */
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import TopicMap from '../../../topic/components/TopicMap';
import { t } from '../../../utils/settings';
import { aiFeature, aiInfo } from '../state';
import { summaryState } from './SummaryPanel';
function canShowSummary(discussion) {
  if (!aiFeature('summary')) return false;
  if (discussion.attribute('canelaAiHasSummary')) return true;
  return !!aiInfo()?.canSummarize && !!discussion.attribute('canelaAiSummarizable');
}
export default function installSummary() {
  extend(TopicMap.prototype, 'view', function (vnode) {
    const discussion = this.attrs.discussion;
    if (!vnode || !Array.isArray(vnode.children) || !canShowSummary(discussion)) return;
    vnode.children.push(m("section", {
      className: "topic-map__additional-contents toggle-summary CanelaTopicMap-ai"
    }, m(Button, {
      className: "Button ai-summarization-button",
      icon: "fas fa-wand-magic-sparkles",
      onclick: () => summaryState.show(discussion)
    }, t('ai.summary.generate'))));
  });

  // O resumo curto (gist) toma o lugar do excerto da lista — o modo
  // "Expandido, com resumos de IA". A lista decide se mostra excertos.
  extend(DiscussionListItem.prototype, 'infoItems', function (items) {
    if (!aiFeature('gists')) return;
    const gist = this.attrs.discussion.attribute('canelaAiGist');
    if (!gist || this.attrs.params?.q) return;
    if (items.has('excerpt')) items.remove('excerpt');
    items.add('excerpt', m("span", {
      className: "CanelaAiGist excerpt"
    }, m("span", {
      className: "excerpt__contents"
    }, gist)), -100);
  });
}
flarum.reg.add('ramon-canela', 'forum/features/ai/summary', installSummary);